/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from "react";
import { Modal, Box, Typography } from "@mui/material";

export default function NetworkStatusModal() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    function handleOnline() {
      setIsOnline(true);
    }
    function handleOffline() {
      setIsOnline(false);
    }

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Limpieza
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <Modal open={!isOnline}>
      <Box
        sx={{
          position: "fixed",
          top: "40%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 2,
          p: 4,
          boxShadow: 24,
          outline: "none",
          width: 300,
          textAlign: "center",
        }}
      >
        <Typography variant="h6" gutterBottom>
          Sin conexión a Internet
        </Typography>
        <Typography variant="body2">
          Por favor verifica tu conexión y vuelve a intentar.
        </Typography>
      </Box>
    </Modal>
  );
}
